import { FormattedNumber } from 'i18n'
import { currencyFromSymbol } from 'shared/currency-utilities'
import Button from '@components/Button'
import { CardSection } from '@components/CardSection'
import { SEARCH_MODE_MONTHLY, SEARCH_MODE_PREPAID } from 'search/constants'

export const Total = ({ totalPrice, currencySymbol }) => {
    const currency = currencyFromSymbol(currencySymbol)

    return (
        <p className="booking__main__section__total">
            <T>booking.total.to.pay.label</T>
            {totalPrice != null && (
                <span className="booking__main__section__total__price">
                    <FormattedNumber value={totalPrice} style="currency" currency={currency} />
                </span>
            )}
        </p>
    )
}

export const RestrictionMessage = () => (
    <CardSection className="restriction" title={<T>booking.restrict-multiple-locations.title</T>}>
        <div>
            <T>booking.restrict-multiple-locations.text</T>
            <Button href="/map" btnStyle="outline">
                <T>booking.restrict-multiple-locations.button</T>
            </Button>
        </div>
    </CardSection>
)

export const LoginForWaitingList = ({ onClickLogin }) => (
    <CardSection className="text-center">
        <Button onClick={onClickLogin}>
            <T>booking.btn.login</T>
        </Button>
    </CardSection>
)

export const validationErrorsInitialState = {
    isSameTicketInBasketError: false,
    selectCardError: false,
    selectRateError: false,
    selectedVehiclesError: false,
    deliveryAddressError: false,
}

export const getBookingValidationErrors = ({
    rate,
    selectedCreditCard,
    isSameTicketInBasket,
    selectedVehicles,
    deliveryAddress,
    parkingMode,
    purchaseValidation = false,
} = {}) => {
    let isValid = true
    let errors = {
        ...validationErrorsInitialState,
    }

    if (!rate) {
        errors = {
            ...errors,
            selectRateError: <T>booking.validation.select.rate</T>,
        }
        isValid = false
    }

    if (parkingMode === SEARCH_MODE_MONTHLY && !deliveryAddress) {
        errors = {
            ...errors,
            deliveryAddressError: <T>booking.validation.addDeliveryAddress</T>,
        }

        isValid = false
    }

    if (parkingMode !== SEARCH_MODE_PREPAID && selectedVehicles && selectedVehicles.length === 0) {
        errors = {
            ...errors,
            selectedVehiclesError: <T>booking.validation.select.vehicle</T>,
        }
        isValid = false
    }

    if (isSameTicketInBasket) {
        errors = {
            ...errors,
            isSameTicketInBasketError: <T>booking.validation.duplicated.tickets</T>,
        }
        isValid = false
    }

    if (purchaseValidation) {
        if (!selectedCreditCard) {
            errors = {
                ...errors,
                selectCardError: <T>booking.validation.select.card</T>,
            }
            isValid = false
        }
    }

    return {
        errors,
        isValid,
    }
}
